'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _defaultsDeep2 = require('lodash/defaultsDeep');

var _defaultsDeep3 = _interopRequireDefault(_defaultsDeep2);

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _desc, _value, _class, _class2, _temp; // based on https://github.com/RakanNimer/react-google-charts

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _chartColors = require('./chart-colors');

var _chartColors2 = _interopRequireDefault(_chartColors);

var _googleChartLoader = require('./google-chart-loader');

var _googleChartLoader2 = _interopRequireDefault(_googleChartLoader);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _chartDefaultOptions = require('./chart-default-options');

var _chartDefaultOptions2 = _interopRequireDefault(_chartDefaultOptions);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Chart = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Chart, _Component);

  function Chart(props, context) {
    (0, _classCallCheck3.default)(this, Chart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).call(this, props));

    _this.state = { graphID: props.graphId || context.getId('chart-') };
    _this.chart = null;
    _this.wrapper = null;
    _this.hiddenColumns = {};
    _this.dataTable = [];

    _this.onResize = _this.onResize.bind(_this); //autobind doesn't work in case of reassigning onResize
    return _this;
  }

  (0, _createClass3.default)(Chart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window === 'undefined') {
        return;
      }
      var _props = this.props,
          loadCharts = _props.loadCharts,
          packages = _props.chartPackages,
          version = _props.chartVersion;

      if (loadCharts) {
        var mapsApiKey = _config2.default.app.googleMaps.apiKey;
        _googleChartLoader2.default.init({ packages: packages, version: version, mapsApiKey: mapsApiKey }).then(this.drawChart);
        this.onResize = (0, _debounce3.default)(this.onResize, 200);
        window.addEventListener('resize', this.onResize);
      } else {
        this.drawChart();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var loadCharts = this.props.loadCharts;

      if (!loadCharts) {
        this.drawChart();
      } else if (_googleChartLoader2.default.isLoading) {
        _googleChartLoader2.default.initPromise.then(this.drawChart);
      } else if (_googleChartLoader2.default.isLoaded) {
        this.drawChart();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (window) {
        if ((0, _get3.default)(window, 'google.visualization')) {
          window.google.visualization.events.removeAllListeners(this.wrapper);
        }
        window.removeEventListener('resize', this.onResize);
      }
      this.wrapper = null;
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      this.drawChart();
    }
  }, {
    key: 'onSelectToggle',
    value: function onSelectToggle() {
      var selection = this.chart.getSelection();
      if (selection) {
        if (selection[0].row === null) {
          var column = selection[0].column;
          this.togglePoints(column);
        }
      }
    }
  }, {
    key: 'getChartOptions',
    value: function getChartOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.options;

      return (0, _defaultsDeep3.default)(options, _chartDefaultOptions2.default);
    }
  }, {
    key: 'getColumnColor',
    value: function getColumnColor(columnIndex) {
      var _getChartOptions = this.getChartOptions(),
          colors = _getChartOptions.colors;

      if (colors) {
        if (colors[columnIndex]) {
          return colors[columnIndex];
        }
      } else if (columnIndex in _chartColors2.default) {
        return _chartColors2.default[columnIndex];
      }
      return _chartColors2.default[0];
    }
  }, {
    key: 'buildDataTableFromProps',
    value: function buildDataTableFromProps() {
      var _props2 = this.props,
          diffdata = _props2.diffdata,
          data = _props2.data;
      var t = this.context.t;

      var result = null;
      var errorMessage = null;
      var error = null;

      if (diffdata) {
        result = this.computeDataTableDiff();
      } else if (data === null) {
        errorMessage = this.validateBuildingDataTableProps();
      } else {
        try {
          this.wrapper.setDataTable(data);
          result = this.wrapper.getDataTable();
          this.formatDataTable({ dataTable: result });
        } catch (err) {
          errorMessage = t('Failed to set DataTable from data props!');
          error = err;
        }
      }

      if (errorMessage) {
        throw new Error(errorMessage, error);
      }

      return result !== null ? result : this.generateDataTable();
    }
  }, {
    key: 'validateBuildingDataTableProps',
    value: function validateBuildingDataTableProps() {
      var _props3 = this.props,
          rows = _props3.rows,
          allowEmptyRows = _props3.allowEmptyRows,
          columns = _props3.columns;
      var t = this.context.t;

      var error = null;

      if (!rows.length && !allowEmptyRows) {
        error = t('Can\'t build DataTable from rows and columns: rows array in props is empty');
      }
      if (!columns.length) {
        error = t('Can\'t build DataTable from rows and columns: columns array in props is empty');
      }

      return error;
    }
  }, {
    key: 'computeDataTableDiff',
    value: function computeDataTableDiff() {
      var _props4 = this.props,
          diffdata = _props4.diffdata,
          chartType = _props4.chartType;
      var oldDiffdata = diffdata.old,
          newDiffdata = diffdata.new;

      var oldData = window.google.visualization.arrayToDataTable(oldDiffdata);
      var newData = window.google.visualization.arrayToDataTable(newDiffdata);
      // must take computeDiff from prototypes since not available with charts early in process
      var computeDiff = window.google.visualization[chartType].prototype.computeDiff;
      return computeDiff(oldData, newData);
    }
  }, {
    key: 'formatDataTable',
    value: function formatDataTable(_ref) {
      var dataTable = _ref.dataTable;
      var _props5 = this.props,
          numberFormat = _props5.numberFormat,
          dateFormat = _props5.dateFormat;


      if (numberFormat) {
        var formatter = new window.google.visualization.NumberFormat(numberFormat.options);
        formatter.format(dataTable, numberFormat.column);
      }

      if (dateFormat) {
        var dateFormatter = new window.google.visualization.DateFormat(dateFormat.options);
        dateFormat.columns.forEach(function (columnIdx) {
          return dateFormatter.format(dataTable, columnIdx);
        });
      }
    }
  }, {
    key: 'generateDataTable',
    value: function generateDataTable() {
      var _props6 = this.props,
          rows = _props6.rows,
          columns = _props6.columns;

      var dataTable = new window.google.visualization.DataTable();
      columns.forEach(function (column) {
        return dataTable.addColumn(column);
      });
      dataTable.addRows(rows);
      this.formatDataTable({ dataTable: dataTable });
      return dataTable;
    }
  }, {
    key: 'updateDataTable',
    value: function updateDataTable() {
      window.google.visualization.errors.removeAll(document.getElementById(this.wrapper.getContainerId()));
      this.dataTable.removeRows(0, this.dataTable.getNumberOfRows());
      this.dataTable.removeColumns(0, this.dataTable.getNumberOfColumns());
      this.dataTable = this.buildDataTableFromProps();
      return this.dataTable;
    }
  }, {
    key: 'drawChart',
    value: function drawChart() {
      var _this2 = this;

      var chartType = this.props.chartType;

      var options = this.getChartOptions();
      var graphID = this.state.graphID;


      if (!this.wrapper) {
        var chartConfig = {
          chartType: chartType,
          options: options,
          containerId: graphID
        };
        this.wrapper = new window.google.visualization.ChartWrapper(chartConfig);
        this.dataTable = this.buildDataTableFromProps();
        this.wrapper.setDataTable(this.dataTable);

        window.google.visualization.events.addOneTimeListener(this.wrapper, 'ready', function () {
          _this2.chart = _this2.wrapper.getChart();
          _this2.listenToChartEvents();
          _this2.addChartActions();
        });
      } else {
        this.updateDataTable();
        this.wrapper.setDataTable(this.dataTable);
        this.wrapper.setOptions(options);
        if (this.wrapper.getChartType() !== chartType) {
          window.google.visualization.events.removeAllListeners(this.wrapper);
          this.wrapper.setChartType(chartType);
          var self = this;
          window.google.visualization.events.addOneTimeListener(this.wrapper, 'ready', function () {
            self.chart = self.wrapper.getChart();
            self.listenToChartEvents.call(self);
          });
        }
      }
      this.wrapper.draw();
    }
  }, {
    key: 'addChartActions',
    value: function addChartActions() {
      var _this3 = this;

      var chartActions = this.props.chartActions;


      if (chartActions === null) {
        return;
      }

      chartActions.forEach(function (chartAction) {
        _this3.chart.setAction({
          id: chartAction.id,
          text: chartAction.text,
          action: chartAction.action.bind(_this3, _this3.chart)
        });
      });
    }
  }, {
    key: 'listenToChartEvents',
    value: function listenToChartEvents() {
      var _this4 = this;

      var _props7 = this.props,
          legendToggle = _props7.legendToggle,
          chartEvents = _props7.chartEvents;


      if (legendToggle) {
        window.google.visualization.events.addListener(this.wrapper, 'select', this.onSelectToggle);
      }
      chartEvents.forEach(function (chartEvent) {
        if (chartEvent.eventName === 'ready') {
          chartEvent.callback(_this4);
        } else {
          (function (event) {
            window.google.visualization.events.addListener(_this4.chart, event.eventName, function (e) {
              event.callback(_this4, e);
            });
          })(chartEvent);
        }
      });
    }
  }, {
    key: 'buildColumnFromSourceData',
    value: function buildColumnFromSourceData(columnIndex) {
      return {
        label: this.dataTable.getColumnLabel(columnIndex),
        type: this.dataTable.getColumnType(columnIndex),
        sourceColumn: columnIndex,
        role: this.dataTable.getColumnRole(columnIndex)
      };
    }
  }, {
    key: 'buildEmptyColumnFromSourceData',
    value: function buildEmptyColumnFromSourceData(columnIndex) {
      return {
        label: this.dataTable.getColumnLabel(columnIndex),
        type: this.dataTable.getColumnType(columnIndex),
        calc: function calc() {
          return null;
        },
        role: this.dataTable.getColumnRole(columnIndex)
      };
    }
  }, {
    key: 'addEmptyColumnTo',
    value: function addEmptyColumnTo(columns, columnIndex) {
      var emptyColumn = this.buildEmptyColumnFromSourceData(columnIndex);
      columns.push(emptyColumn);
    }
  }, {
    key: 'hideColumn',
    value: function hideColumn(colors, columnIndex) {
      if (!this.isHidden(columnIndex)) {
        this.hiddenColumns[columnIndex] = { color: this.getColumnColor(columnIndex - 1) };
      }
      colors.push('#CCCCCC');
    }
  }, {
    key: 'addSourceColumnTo',
    value: function addSourceColumnTo(columns, columnIndex) {
      var sourceColumn = this.buildColumnFromSourceData(columnIndex);
      columns.push(sourceColumn);
    }
  }, {
    key: 'isHidden',
    value: function isHidden(columnIndex) {
      return this.hiddenColumns[columnIndex] !== undefined;
    }
  }, {
    key: 'restoreColorTo',
    value: function restoreColorTo(colors, columnIndex) {
      var previousColor = void 0;
      if (this.isHidden(columnIndex)) {
        previousColor = this.hiddenColumns[columnIndex].color;
        delete this.hiddenColumns[columnIndex];
      } else {
        previousColor = this.getColumnColor(columnIndex - 1);
      }
      if (columnIndex) {
        colors.push(previousColor);
      }
    }
  }, {
    key: 'togglePoints',
    value: function togglePoints(column) {
      var _this5 = this;

      var options = this.getChartOptions();
      var view = new window.google.visualization.DataView(this.wrapper.getDataTable());
      var columnCount = view.getNumberOfColumns();
      var colors = [];
      var columns = [];

      var hide = function hide(_ref2) {
        var columnIndex = _ref2.columnIndex;

        _this5.addEmptyColumnTo(columnIndex);
        _this5.hideColumn(columnIndex);
      };
      var show = function show(_ref3) {
        var columnIndex = _ref3.columnIndex;

        _this5.addSourceColumnTo(columns, columnIndex);
        _this5.restoreColorTo(colors, columnIndex);
      };

      for (var columnIndex = 0; columnIndex < columnCount; columnIndex += 1) {
        var isHidden = this.isHidden(columnIndex);
        // If user clicked on legend
        if (!columnIndex) {
          this.addSourceColumnTo(columns, columnIndex);
        } else if (columnIndex === column) {
          if (isHidden) {
            show({ columnIndex: columnIndex });
          } else {
            hide({ columnIndex: columnIndex });
          }
        } else if (isHidden) {
          hide({ columnIndex: columnIndex });
        } else {
          show({ columnIndex: columnIndex });
        }
      }
      view.setColumns(columns);
      options.colors = colors;
      this.chart.draw(view, options);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props8 = this.props,
          height = _props8.height,
          width = _props8.width,
          loader = _props8.loader;
      var t = this.context.t;
      var graphID = this.state.graphID;

      var options = this.getChartOptions();

      var divStyle = {
        height: height || options.height,
        width: width || options.width
      };
      return _react2.default.createElement(
        'div',
        { id: graphID, style: divStyle },
        loader || t('Rendering Chart...')
      );
    }
  }]);
  return Chart;
}(_react.Component), _class2.propTypes = {
  allowEmptyRows: _propTypes2.default.bool,
  chartActions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    text: _propTypes2.default.string,
    action: _propTypes2.default.func
  })),
  chartEvents: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    eventName: _propTypes2.default.string,
    callback: _propTypes2.default.func
  })),
  chartPackages: _propTypes2.default.arrayOf(_propTypes2.default.string),
  chartType: _propTypes2.default.string,
  chartVersion: _propTypes2.default.string,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.object),
  data: _propTypes2.default.arrayOf(_propTypes2.default.array),
  dateFormat: _propTypes2.default.shape({
    columns: _propTypes2.default.arrayOf(_propTypes2.default.number),
    options: _propTypes2.default.shape({
      formatType: _propTypes2.default.string,
      pattern: _propTypes2.default.string,
      timeZone: _propTypes2.default.number
    })
  }),
  diffdata: _propTypes2.default.shape({
    on: _propTypes2.default.array,
    off: _propTypes2.default.array
  }),
  graphId: _propTypes2.default.string,
  height: _propTypes2.default.string,
  legendToggle: _propTypes2.default.bool,
  loadCharts: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  numberFormat: _propTypes2.default.shape({
    column: _propTypes2.default.number,
    options: _propTypes2.default.shape({
      decimalSymbol: _propTypes2.default.string,
      fractionDigits: _propTypes2.default.number,
      groupingSymbol: _propTypes2.default.string,
      negativeColor: _propTypes2.default.string,
      negativeParens: _propTypes2.default.bool,
      pattern: _propTypes2.default.string,
      prefix: _propTypes2.default.string,
      suffix: _propTypes2.default.string
    })
  }),
  options: _propTypes2.default.object,
  rows: _propTypes2.default.arrayOf(_propTypes2.default.array),
  width: _propTypes2.default.string
}, _class2.defaultProps = {
  allowEmptyRows: false,
  chartActions: null,
  chartEvents: [],
  chartPackages: ['corechart'],
  chartType: 'LineChart',
  chartVersion: 'current',
  columns: [],
  data: null,
  dateFormat: null,
  diffdata: null,
  height: '300px',
  legendToggle: false,
  loadCharts: true,
  loader: _react2.default.createElement(_Loader2.default, { alignCenter: true }),
  numberFormat: null,
  options: {
    chart: {
      title: 'Chart Title',
      subtitle: 'Subtitle'
    },
    hAxis: { title: 'X Label' },
    vAxis: { title: 'Y Label' },
    width: '100%',
    height: '300px'
  },
  rows: [],
  width: '100%'
}, _class2.contextTypes = {
  getId: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSelectToggle', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelectToggle'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buildDataTableFromProps', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'buildDataTableFromProps'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDataTable', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDataTable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'drawChart', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'drawChart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addChartActions', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addChartActions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'listenToChartEvents', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'listenToChartEvents'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideColumn', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hideColumn'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addSourceColumnTo', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addSourceColumnTo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'restoreColorTo', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'restoreColorTo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePoints', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePoints'), _class.prototype)), _class);
exports.default = Chart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/Chart.js
// module id = 1964
// module chunks = 1